import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import cx from 'classnames';

import { ArrowFullLeftIcon } from '@motorway/mw-highway-code';

import styles from './BackButton.module.scss';

export const BackButton = ({ padding = false, to }: { padding?: boolean; to?: string }) => {
  const navigate = useNavigate();

  const back = to
    ? (
        <Link data-thc-style-override className={styles.backLink} to={to}>
          <ArrowFullLeftIcon />
        </Link>
      )
    : (
        <div onClick={() => navigate(-1)}>
          <ArrowFullLeftIcon />
        </div>
      );

  return (
    <div className={cx(styles.backButton, { [styles.padding]: padding })}>
      {back}
    </div>
  );
};
